import React from 'react';

export const ChevronRight = () => (
    <polyline points='9 6 15 12 9 18' />
);